export type RentalStatus = "rented" | "returned";

export type RentalRecord = {
    id: string | number | null;
    equipmentName: string;
    projectId: number | null;
    projectName: string;
    renterId: string;
    renterName: string;
    renter: {
        label: string;
        value: string;
        department?: string | null;
    } | null;
    department: string;
    rentalStartDate: string;
    rentalExpireDate: string;
    status: RentalStatus;
    notes: string;
    returnedById: string;
    returnedByName: string;
    returnedBy: {
        label: string;
        value: string;
    } | null;
    rentalReturnDate: string;
    returnNotes: string;
    creatorId: string;
    creatorName: string;
    createdAt: string;
    updaterId: string;
    updaterName: string;
    updatedAt: string;
    void: "yes" | "no";
    voidReason: string;
};

export const defaultRentalRecord: RentalRecord = {
    id: null,
    equipmentName: "",
    projectId: null,
    projectName: "",
    renterId: "",
    renterName: "",
    renter: null,
    department: "",
    rentalStartDate: "",
    rentalExpireDate: "",
    status: "rented",
    notes: "",
    returnedById: "",
    returnedByName: "",
    returnedBy: null,
    rentalReturnDate: "",
    returnNotes: "",
    creatorId: "",
    creatorName: "",
    createdAt: "",
    updaterId: "",
    updaterName: "",
    updatedAt: "",
    void: "no",
    voidReason: "",
};
